import ScalarSidebarButton_vue_vue_type_script_setup_true_lang_default from "./ScalarSidebarButton.vue.script.js";
//#region src/components/ScalarSidebar/ScalarSidebarButton.vue
var ScalarSidebarButton_default = ScalarSidebarButton_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarSidebarButton_default as default };

//# sourceMappingURL=ScalarSidebarButton.vue.js.map